<template>
  <div class="footer">
    <div class="content">
      <div class="content_left">
        <!-- <div class="link_wrap"> -->
          <!-- <div class="link_title">友情链接</div> -->
          <!-- <div class="link_item"><a href="http://www.moe.gov.cn/" target="_blank">教育部</a> </div> -->
          <!-- <div class="link_item"><a href="https://www.ncet.edu.cn/zhuzhan/index.html" target="_blank">中央电化教育馆</a> </div> -->
          <!-- <div class="link_item"><a href="http://emic.moe.edu.cn/" target="_blank">教育部教育管理信息中心</a> </div> -->
          <!-- <div class="link_item"><a href="http://www.cse.edu.cn/" target="_blank">中国教育学会</a> </div> -->
          <!-- <div class="link_item"><a href="http://www.caet.org.cn/" target="_blank">中国教育技术协会</a></div> -->
          <!-- <div class="link_item" style="border-right:none"><a href="https://www.cnu.edu.cn/" target="_blank">首都师范大学</a></div> -->
          <!-- <div class="link_item">书香中国</div>
          <div class="link_item" style="border-right:none">乐智悦读</div> -->
        <!-- </div> -->
        <div class="info_wrap flex-layout">
          <div class="info_left">联系我们:</div>
          <div class="info_right flex-column">
            <div class="info_us">{{team}}</div>
            <div class="flex-align info_item">
              <!-- <img src="@/assets/img/footer/phone.png" /> -->
              <span>{{info.phone || phone}}</span>
            </div>
            <!-- <div class="flex-align info_item">
              <img src="@/assets/img/footer/man.png" width="17px" height="17px" style="opacity:0.7;padding-left:1px"/>
              <span>{{info.tel || telePhone}}</span>
            </div> -->
            <div class="flex-align info_item">
              <!-- <img src="@/assets/img/footer/email.png" /> -->
              <span>{{info.email || email}}</span>
            </div>
            <div class="flex-align info_item">
              <!-- <img src="@/assets/img/footer/address.png" /> -->
              <span>联系地址:北京市海淀区西三环北路105号</span>
            </div>
            <!-- <div class="flex-align info_item">
              <img src="@/assets/img/footer/time.png" />
              <span>服务时间:{{info.work || time}}</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="content_right">
        <div class="qrcode qrcode1" v-for="(item, index) in 1" :key="index">
          <!-- <img src="@/assets/qrcode.jpg" /> -->
          <img src="../../assets/home/WechatIMG19.jpeg" />
          <span>CCPT书画等级考试中心</span>
        </div>

      </div>
    </div>
    <div class="records_wrap">
        <!-- <div>copyright@2020首都师范大学</div>
        <div class="support">技术支持:首都师范大学"双优云桥"项目组</div>
        <div>京ICP备:110402430068号</div> -->
        <!-- <div>copyright@2020首都师范大学</div> -->
        <!-- <div class="support">首都示范大学 "双优云桥" 项目组</div> -->
          <p class="" > <img src="../../assets/home/icon.jpg" alt=""> <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802039093" style="color:#fff">京公网安备11010802039093号</a>
            <span> <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" style="color:#fff">京ICP备17019635号-6​</a></span>​</p>
         

    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            info:{},
            QRcodeList:[],
            team:'CCPT书画等级考试',
            phone:'010-88512948',
            telePhone:'13301362095',
            email:'yd@lezhireading.com',
            address:'北京市海淀区西三环北路105号',
            // time:'周一至周五  9：00~18：00'
        }
    },
    methods:{
      async getInfo (){
          let resData = await Api.Home.getFooterInfo()
          let msg = JSON.parse(resData.data.value);
          // console.log(msg);
          this.info = msg;
      },
      async getQRcode (){
          let resData = await Api.Home.getQRcode()
          // console.log(resData)
          resData.data.forEach((item, index) => {
            item.url = this.imageURL +item.url
          })
          this.QRcodeList = resData.data;
      },
    },
    mounted(){
      // this.getInfo();
      // this.getQRcode();
    }
};
</script>

<style lang="less">
@import "./less/footer.less";
</style>